import { Injectable } from '@angular/core';
import { Http, Response ,HttpModule} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { fleetDealerVm, BASE_URL, CusInfoForeDealerVM, EquipmentVM, CompenentForecastVM, ForecastVM, userID } from './component-forecast.model';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError } from 'rxjs/operators';
import { HttpClientModule, HttpParams, HttpResponse } from '@angular/common/http';
import { Family } from '../../entities';

@Injectable()
export class ComponentForecastService {

  dealerList:fleetDealerVm[]
  customerList:CusInfoForeDealerVM[]
  equipmentList :EquipmentVM[]
  userId:number
  familyList:Family[]
  user:userID[]
  constructor(private _http: Http,

    ) {

     }

  // get Dealer List
//   public getDealerList(){

//     this._http.get(`${BASE_URL}/getAllDealerList`).map((data:Response)=>{
//       return data.json() as fleetDealerVm[];
//     }).toPromise().then(r=>{
//       this.dealerList = r;
//     })
// }

public getDealerList(userName:string) :Observable<fleetDealerVm>{
  let obj = {
    'userName': userName
  };
  return this._http
    .post(`${BASE_URL}/getAllDealerList`, obj)
    .map((response: Response) => {
      return response.json()
    }).pipe(catchError(this.handleError));
}

public getCustomerListByDealer(DealerId: number):Observable<CusInfoForeDealerVM> {
  let obj = {
    'DealerId': DealerId
  };
  return this._http
    .post(`${BASE_URL}/getCustomerLsitForeDealer`, obj)
    .map((response: Response) => {
      return response.json()
    }).pipe(catchError(this.handleError));
}

public getCustomerList(userName:string):Observable<CusInfoForeDealerVM>{
  let obj = {
    'userName': userName
  };
  return this._http
  .post(`${BASE_URL}/getCustomerList`, obj)
  .map((response: Response) => {
    return response.json()
  }).pipe(catchError(this.handleError));
}

public getJobSiteListByCustomer(customerID: number) {
  let obj = {
    'customerID': customerID
  };
  return this._http
    .post(`${BASE_URL}/getJobSiteLsitForeCustomerr`, obj)
    .map((response: Response) => {
      return response.json()
    }).pipe(catchError(this.handleError));
}

public getEquipmentList(jobsiteID: number) {
  let obj = {
    'jobsiteID': jobsiteID
  };
  return this._http
    .post(`${BASE_URL}/getEquipmentList`, obj)
    .map((response: Response) => {
      return response.json()
    }).pipe(catchError(this.handleError));
}

public getUserId() {
  //return this._http.get("api/interpretation/GetUserId").pipe(catchError(this.handleError));
  this._http.get(`api/interpretation/GetUserId`).map((data:Response)=>{
    return data.json() as userID[];
  }).toPromise().then(r=>{
    this.user = r;
  })
}

public getFamilyList() {
  this._http.get(`${BASE_URL}/getAllFamilyList`)
    .map((data: Response) => {
      return data.json() as Family[];
    }).toPromise().then(x => {
      this.familyList = x;
    })
}

public getcompForecastInfo(dealerID: number, startdate:Date, enddate:Date,interval:number,cusID:number,jobsiteID:number,
  makeid:number,typeid:number,modelID:number,comptypeID:number,equipmentid_auto:number) : Observable<ForecastVM[]> {
  let obj = {
    'dealerID': dealerID,
    'startdate':startdate,
    'enddate':enddate,
    'interval':interval,
    'cusID':cusID,
    'jobsiteID':jobsiteID,
    'makeid':makeid,
    'typeid':typeid,
    'modelID':modelID,
    'comptypeID':comptypeID,
    'equipmentid_auto':equipmentid_auto

  };
  return this._http
    .post(`${BASE_URL}/getCalcInforComponentFleet`, obj)
    .map((response: Response) => {
      return response.json()
    }).pipe(catchError(this.handleError));
}

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}

}
